import React from "react";
import {PanelSettingsDrawer} from "./settings-drawer";
import {Drawer, drawerClasses, Theme} from "@mui/material";
import {SxProps} from "@mui/system";
import {usePanel} from "../../layout";

export interface PanelDrawersProps {
}

export const PanelDrawers: React.FC<PanelDrawersProps> = (props) => {
    const {drawersOpenState, setDrawersOpenState} = usePanel();

    /**
     * Closes the settings drawer.
     */
    const closeSettingsDrawer = React.useCallback(() => {
        setDrawersOpenState(prevState => ({...prevState, settingsDrawer: false}));
    }, [setDrawersOpenState]);

    /**
     * Creates the styles for the start sidebar drawer component.
     */
    const settingsDrawerSx = React.useMemo<SxProps<Theme>>(() => [
        {
            [`& .${drawerClasses.paper}`]: {
                boxSizing: 'border-box',
                backgroundColor: 'background.paper',
                width: `min(360px, 100vw)`,
                boxShadow: (theme) => `-40px 40px 80px -8px rgba(${theme.vars.palette.grey['500Channel']} / 24%)`,
            },
        },
        (theme) => theme.applyStyles('dark', {
            [`& .${drawerClasses.paper}`]: {
                boxShadow: `-40px 40px 80px -8px rgba(0 0 0 / 24%)`,
            },

        }),
    ], []);

    return (
        <>
            <Drawer
                keepMounted
                anchor={'right'}
                variant={"temporary"}
                open={drawersOpenState.settingsDrawer}
                onClose={closeSettingsDrawer}
                sx={settingsDrawerSx}
                slotProps={{backdrop: {invisible: true}}}
            >
                <PanelSettingsDrawer
                    close={closeSettingsDrawer}
                />
            </Drawer>
        </>
    );
}